export type FeatureFlagValue = string | boolean;

export type FeatureFlags = Record<string, FeatureFlagValue>;

export const PDP_BUY_BUTTON_COPY_FLAG = 'PDP_BUY_BUTTON_COPY';

export const PDP_BUY_BUTTON_COPY_PROCEED = 'proceed';

const knownFlags = new Set([PDP_BUY_BUTTON_COPY_FLAG]);

export function isKnownFeatureFlag(flag: string) {
  return knownFlags.has(flag);
}
